/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 内容 */
  getProducts: RootPath + 'Plugin/user/website/product/index',
  getProduct: RootPath + 'Plugin/user/website/product/getForm',
  saveProduct: RootPath + 'Plugin/user/website/product/save',
  delProducts: RootPath + 'Plugin/user/website/product/delete',
  /* 内容类别 */
  getProductCategories: RootPath + 'Plugin/user/website/product/getCategoryList',
  getProductCategory: RootPath + 'Plugin/user/website/product/getCategoryForm',
  saveProductCategory: RootPath + 'Plugin/user/website/product/saveCategory',
  delProductCategories: RootPath + 'Plugin/user/website/product/delCategories',
}

export default apis
